export default [
  {
    title: 'breadcrumb.management',
    icon: 'BriefcaseIcon',
    children: [
      {
        title: 'breadcrumb.project',
        route: 'list-project',
        icon: '',
        resource: 'manage-project',
        action: 'read',
      },
      {
        title: 'breadcrumb.department',
        route: 'list-department',
        icon: '',
        resource: 'manage-department',
        action: 'read',
      },
      {
        title: 'breadcrumb.workingTime',
        route: 'working-time',
        icon: '',
        // resource: 'manage-working-schedule',
        resource: 'manage-department',
        action: 'read',
      },
      {
        title: 'breadcrumb.employee',
        route: 'list-operator',
        icon: '',
        resource: 'manage-users',
        action: 'read',
      },
      {
        title: 'breadcrumb.rolePermission',
        route: 'list-role',
        icon: '',
        resource: 'manage-role',
        action: 'read',
      },
    ],
  },
]
